import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { Proxy, withArtifex } from "core";
import DateHelper from "core/DateHelper";
import PropTypes from "prop-types";
import React, { Component } from "react";
import ButtonToolbar from "views/Components/ButtonToolbar.jsx";
import { GenericDateInput, GenericExpansionPanel, GenericGrid, GenericTextInput, GenericTitle } from "views/Components/Generic";
import LoadingComponent from "views/Components/LoadingComponent";
import { GridColumnType } from "views/Constants/Constant";

class MastercardSettlementPositionDetail extends Component {
	constructor(props) {
		super(props);

		this.initialModel = {
			Id: 0,
			FromDate: DateHelper.GetLocalDateAsUtc(),
			ToDate: DateHelper.GetLocalDateAsUtc(),
			FileName:""
		};

		this.state = {
			model: {...this.initialModel},
			vModel: {},
			list: [],
			isLoading: false,
			
		};


		this.emptyObject = {};

		this.maxLength26 = { maxLength: 26 };


		this.Columns = [
			{
				Header: "Clearing Date",
				accessor: "MastercardSettlementPositionDetail.ClearingDate",
				type: GridColumnType.DateTime
			},
			{
				Header: "File Name",
				accessor: "FileName"
			},
			{
				Header: "Mti",
				accessor: "MastercardSettlementPositionDetail.Mti"
			},
			{
				Header: "Function Code",
				accessor: "MastercardSettlementPositionDetail.De024"
			},
			{
				Header: "Message Reason Code",
				accessor: "MastercardSettlementPositionDetail.De025"
			},
			{
				Header: "Currency Exponents",
				accessor: "MastercardSettlementPositionDetail.Pds0148"
			},
			{
				Header: "Reconciled File",
				accessor: "MastercardSettlementPositionDetail.Pds0300"
			},
			{
				Header: "Reconciled Member Activity",
				accessor: "MastercardSettlementPositionDetail.Pds0302"
			},
			{
				Header: "Reconciled Business Activity",
				accessor: "MastercardSettlementPositionDetail.Pds0358"
			},
			{
				Header: "Reconciled Settlement Activity",
				accessor: "MastercardSettlementPositionDetail.Pds0359"
			},
			{
				Header: "Reconciled Card Program Identifier",
				accessor: "MastercardSettlementPositionDetail.Pds0367"
			},
			{
				Header: "Reconciled Transaction Function Group Code",
				accessor: "MastercardSettlementPositionDetail.Pds0368"
			},
			{
				Header: "Reconciled Acquirer’s BIN",
				accessor: "MastercardSettlementPositionDetail.Pds0369"
			},
			{
				Header: "Debit/Credit Indicator(Reconcilation Debit)",
				accessor: "MastercardSettlementPositionDetail.Pds0390_1"
			},
			{
				Header: "Transaction Amount(Reconcilation Debit Amount)",
				accessor: "MastercardSettlementPositionDetail.Pds0390_2"
			},
			{
				Header: "Debit/Credit Indicator(Reconcilation Credit)",
				accessor: "MastercardSettlementPositionDetail.Pds0391_1"
			},
			{
				Header: "Transaction Amount(Reconcilation Credit Amount)",
				accessor: "MastercardSettlementPositionDetail.Pds0391_2"
			},
			{
				Header: "Fee Amounts in Reconciliation Currency(Debit)",
				accessor: "MastercardSettlementPositionDetail.Pds0392"
			},
			{
				Header: "Fee Amounts in Reconciliation Currency(Credit)",
				accessor: "MastercardSettlementPositionDetail.Pds0393"
			},
			{
				Header: "Debit/Credit Indicator(Reconciliation Currency)",
				accessor: "MastercardSettlementPositionDetail.Pds0394_1"
			},
			{
				Header: "Net Amount(Reconcilation Currency)",
				accessor: "MastercardSettlementPositionDetail.Pds0394_2"
			},
			{
				Header: "Net Fee in Reconciliation Currency Debit/Credit Indicator",
				accessor: "MastercardSettlementPositionDetail.Pds0395_1"
			},
			{
				Header: "Net Fee Amount in Reconcilation Currency",
				accessor: "MastercardSettlementPositionDetail.Pds0396_1"
			},
			{
				Header: " Net Total Debit/Credit Indicator in Reconciliation Currency",
				accessor: "MastercardSettlementPositionDetail.Pds0396_2"
			},
			{
				Header: "Transaction Currency Code",
				accessor: "MastercardSettlementPositionDetail.De049"
			},
			{
				Header: "Reconcilation Currency Code",
				accessor: "MastercardSettlementPositionDetail.De050"
			},
			{
				Header: "Additional Data 2",
				accessor: "MastercardSettlementPositionDetail.De062"
			},
			{
				Header: "Message Number",
				accessor: "MastercardSettlementPositionDetail.De071"
			},
			{
				Header: "Transaction Destination Institution ID Code",
				accessor: "MastercardSettlementPositionDetail.De093"
			},
			{
				Header: "Receiving Institution ID Code",
				accessor: "MastercardSettlementPositionDetail.De100"
			},
			{
				Header: "Additional Data 3",
				accessor: "MastercardSettlementPositionDetail.De123"
			},
			{
				Header: "Additional Data 4",
				accessor: "MastercardSettlementPositionDetail.De124"
			},
			{
				Header: "Additional Data 5",
				accessor: "MastercardSettlementPositionDetail.De125"
			},
			


		];
	}

	componentDidMount() {
		this.props.setAppLeftTitle("Mastercard Settlement Position Detail List");
		this.props.setAppCenterTitle("CLEARING AND SETTLEMENT");
	}

	HandleChange = (name, newValue, data) => {
		const model = { ...this.state.model };
		model[name] = newValue;
		this.setState({ model });
	}

	HandleClear = () => {
		this.setState({ model: { ...this.initialModel }, isEdit: false, index: -1 });
	}

	HandleSearch = () => {
		const model = { ...this.state.model };
		this.setState({ isLoading: true });
		Proxy.POST
			(
				"/prepaidapi/v1.0/MastercardSettlement/SeearchSettlementPositionDetail",
				model,
				(responseData) => {
					this.setState({ isLoading: false });
					if (!responseData.IsSucceeded) {
						this.props.showMessage("error", "Error", responseData.ErrorDescription);
						return;
					}
					if (responseData.Item !== null) {
						this.setState({
							list: responseData.Item
						});
					}

				},
				(error) => {
					this.setState({ isLoading: false });
					this.props.showMessage("error", "Error", error);
				}
			);

	}

	render() {
		const { Disabled } = this.props;
		const { alert, model, list, isLoading, index, vModel } = this.state;


		return (
			<div>
				<LoadingComponent Show={isLoading} />
				{alert}
				<ButtonToolbar ButtonList={[
					{ Code: "Search", OnClick: this.HandleSearch, Disabled: Disabled },
					{ Code: "Clear", OnClick: this.HandleClear, Disabled: Disabled },
				]} menuId={this.props.menuId} ApprovalData={this.props.ApprovalData} After={this.props.After} />


				<GridContainer>
					<GridItem xs={12}>
						<Card className="no-radius">
							<CardBody>
								<GenericExpansionPanel Title="Main Panel">
									<GridContainer>
										<GridItem xs={12}>
											<GridContainer>
												<GridItem xs={6}>
													<GenericDateInput
														Utc
														Name="FromDate"
														LabelText="From Date"
														Value={model.FromDate ? DateHelper.ToDateInputValue(model.FromDate) : ""}
														ValueChanged={this.HandleChange}
														Required
														IsInvalid={vModel.FromDate}
													/>
													<GenericDateInput
														Utc
														Name="ToDate"
														LabelText="To Date"
														Value={model.ToDate ? DateHelper.ToDateInputValue(model.ToDate) : ""}
														ValueChanged={this.HandleChange}
														MinDate={model.ToDate}
														Required
														IsInvalid={vModel.ToDate}
													/>
												</GridItem>
												<GridItem xs={6}>
													<GenericTextInput
														Name="FileName"
														LabelMd={4}
														LabelText="File Name"
														inputProps={this.maxLength26}
														IsText={true}
														Value={model.FileName}
														ValueChanged={this.HandleChange}
													/>
												</GridItem>
											</GridContainer>
										</GridItem>
									</GridContainer>
								</GenericExpansionPanel>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
				<GridContainer>
					<GridItem xs={12}>
						<Card className="no-radius">
							<CardHeader>
								<GenericTitle text={"Mastercard Financial POS List"} />
							</CardHeader>
							<CardBody>
								<GridContainer spacing={16}>
									<GridItem xs={12}>
										<GenericGrid
											Data={list}
											Columns={this.Columns}
											SelectedIndex={index}
											ShowPagination={true}
										/>
									</GridItem>
								</GridContainer>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
			</div >
		);
	}
}

MastercardSettlementPositionDetail.propTypes = {
	classes: PropTypes.object.isRequired,
	Disabled: PropTypes.bool
};

export default withArtifex(MastercardSettlementPositionDetail, {});